export function RecruitmentHubFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/recruitment-hub-filled.svg'"></ng-include>`
    }
}